import styled from 'styled-components';

export const Container = styled.div`
  > img {
    display: block;
    margin: 10px auto;
  }

  > button {
    font-family: 'Montserrat';
    font-size: 1.6rem;
    color: #939393;
    background-color: #fff;
  }

  @media (max-width: 1024px) {
    margin-top: 40px;
  }

  @media (max-width: 560px) {
    width: 100%;
    > button {
      margin-top: 40px;
      width: 100%;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const AddButton = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--purple84);
  display: flex;
  align-items: center;
  justify-content: center;

  > span {
    font-family: 'Montserrat';
    font-size: 3rem;
    color: #fff;
    margin-left: 0px;
  }
`;

export const AddCard = styled.span`
  font-family: 'Montserrat';
  font-size: 1.4rem;
  color: var(--green24);
  margin-left: 10px;
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
  text-align: center;
`;
